import ComponentCard from "../../microComponents/elements/ComponentCard";
import Title from "../../microComponents/elements/Title";
import {Button, Select} from "antd";
import Cookies from "js-cookie";
import React, {useEffect, useState} from "react";
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import {getFilterLocation} from "../../microComponents/tablePages/getFilterLocation";
import DeleteFilterTable from "../../microComponents/tablePages/filter/DeleteFilterTable";
import UseSetParams from "../../microComponents/tablePages/filter/UseSetParams";
import ShowSearchBtn from "../../microComponents/tablePages/ShowSearchBtn";
import {toast} from "react-toastify";
import Pallet from "../../http_request/Model/pallet/Pallet";

import CreatorTable from "../../microComponents/tablePages/CreatorTable";
import StoreColumn from "./StoreColumn";
import {useDispatch, useSelector} from 'react-redux';
import {getDataRows, getFilter, isLoading} from "../../store/TableRedux/TableRedux";
import Cards from "./Cards";
import {useNavigate, useSearchParams} from "react-router-dom";
import CollapseBox from "../../microComponents/tablePages/CollapseBox";
import TopSearchMap from "./TopSearchMap";
import MapComponent from "./MapComponent";


const MapPage = () => {
    const dispatch = useDispatch();
    const filter = useSelector((state) => state.TableRedux.filter);
    const loading = useSelector((state) => state.TableRedux.loading);
    const navigate = useNavigate();
    const showSearchBox = useSelector((state) => state.TableRedux.showSearchBox);
    const [searchParams] = useSearchParams();
    const stringifyFilter = JSON.stringify(filter);
    const [, handleDeleteParams] = UseSetParams();
    const [columns] = StoreColumn();
    const [selectedBranch, setSelectedBranch] = useState();
    const [branchList, setBranchList] = useState([]);
    const [defLoading, setDefLoading] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState();
    const [locationList, setLocationList] = useState([]);
    const [showStatus, setShowStatus] = useState(true);
    const [svg, setSvg] = useState();
    const [data, setData] = useState({});


    useEffect(() => {
        console.log(88888)
    }, [data
         ]);



    useEffect(() => {
        getFilterBranch(setBranchList, setDefLoading)
        dispatch(getDataRows([]));

    }, [dispatch]);


    useEffect(() => {
        dispatch(isLoading(defLoading));
    }, [dispatch,defLoading]);


    useEffect(() => {
        if (branchList.length) {
            setSelectedBranch(branchList[0].value)
        }
    }, [branchList]);


    useEffect(() => {
        let params = {};
        // eslint-disable-next-line no-restricted-syntax
        for (const [k, v] of searchParams.entries()) {
            params = {...params, [k]: v};
        }

        dispatch(getFilter({...params}));

    }, [searchParams, dispatch]);


    useEffect(() => {
        if (locationList.length) {
            setSelectedLocation(locationList[0].value)
        }
    }, [locationList]);

    useEffect(() => {

        if (selectedLocation) {
            Pallet.request({
                beforeSend: () => {
                    dispatch(isLoading(true));
                },
                success: ({result}) => {
                    setData(result);
                    setShowStatus(!result.mapAddress)
                    setSvg(result.mapSvg)
                    dispatch(getDataRows(result.inventoryListDTOs));

                },
                error: ({error}) => {
                    toast.error(error.data.message);
                },
                final: (data) => {
                    dispatch(isLoading(false));
                },
            }).addParams({id: selectedLocation, ...filter}, true).LocationInfo();
        }
    }, [selectedLocation,   dispatch, stringifyFilter]);


    useEffect(() => {
        if (selectedBranch) {
            setLocationList([])
            setSelectedLocation(null)
            getFilterLocation(setLocationList, setDefLoading, selectedBranch,)

        }


    }, [selectedBranch]);


    return (
        <div>
            <ComponentCard>


                <div className='flex justify-between flex-wrap'>
                    <Title>انبارها</Title>
                    <div className='flex gap-2 flex-wrap'>
                        <div className='flex gap-2 min-w-80 flex-1'>
                            <Select showSearch placeholder='واحد' className="flex-1"
                                    loading={loading}
                                    filterOption={(input, option) => {
                                        return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                    }}
                                    onChange={(e) => {
                                        setSelectedBranch(e)
                                        Cookies.set('ProductLine', e)
                                    }}

                                    optionFilterProp='label'
                                    defaultValue={selectedBranch}
                                    value={selectedBranch}
                                    options={branchList}/>
                            <Select
                                showSearch placeholder='انبار' className="flex-1"
                                loading={loading}
                                filterOption={(input, option) => {
                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                }}
                                onChange={(e) => {
                                    setSelectedLocation(e)
                                    Cookies.set('ProductLine', e)
                                }}
                                optionFilterProp='label'
                                defaultValue={selectedLocation}
                                value={selectedLocation}
                                options={locationList}/>
                        </div>
                        <div className='flex gap-2 justify-end  flex-1'>
                            <Button disabled={!svg} className='defBtn blueBtn !px-4' onClick={() => {
                                setShowStatus(prevState => !prevState)
                            }}>{

                                showStatus ? 'نقشه' : 'جدول'
                            } </Button>
                            <DeleteFilterTable onClick={handleDeleteParams}/>
                            <ShowSearchBtn/>
                        </div>


                    </div>

                </div>
                <div className='searchBox p-0'>
                    <CollapseBox activeKey={showSearchBox ? ['1'] : null} items={[{
                        showArrow: false, headerPadding: '1px', className: 'bg-white border-none',
                        key: '1', children: <TopSearchMap selectedLocation={selectedLocation}/>,
                    }]}/>

                </div>
            </ComponentCard>

            <Cards data={data} selectedLocation={selectedLocation}/>
            <ComponentCard>
                {
                    showStatus
                        ?
                        <CreatorTable clearData={false} columns={columns} showPagination={false}
                                      onDoubleClickRowHandler={(row) => {
                                          navigate(`/PalletStatus?locations=${selectedLocation}&product=${row.productCode}&IsExit=false`);

                                      }}/>
                        :
                        <MapComponent selectedLocation={selectedLocation} data={data} svg={svg}/>
                }


            </ComponentCard>
        </div>
    );
};

export default MapPage;